module.exports = "https://trybtryb-legacy.web.app/img/thinking-like-entrepeuner-desktop.05ead391.webp";